import { render, staticRenderFns } from "./SubscriptionDetails.vue?vue&type=template&id=0a880d1a&"
import script from "./SubscriptionDetails.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports